import React, { useRef, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Document, Page } from "react-pdf/dist/entry.webpack";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { DocumentWrapper } from "./styles/display-pdf-styles";

const DisplayPdf = ({ data }) => {
  const [numberOfPages, setNumberOfPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(undefined);

  const onDocumentLoad = ({ numPages }) => {
    setNumberOfPages(numPages);
  };

  const observer = useRef(null);

  const observerCallback = useCallback((entries) => {
    const { width } = entries[0].contentRect;
    setPageWidth(width);
  }, []);

  const pdfWrapper = useCallback(
    (node) => {
      if (node !== null) {
        if (observer.current) {
          observer.current.disconnect();
        }
        observer.current = new ResizeObserver(observerCallback);
        observer.current.observe(node);
      }
    },
    [observerCallback]
  );

  useEffect(
    () => () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    },
    []
  );

  if (!data) {
    return <div>Loading Page...</div>;
  }

  return (
    <DocumentWrapper ref={pdfWrapper}>
      <Document file={data} onLoadSuccess={onDocumentLoad}>
        {Array.from(new Array(numberOfPages), (el, index) => (
          <Page
            width={pageWidth}
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            className="cv__canvas--unset-height"
          />
        ))}
      </Document>
    </DocumentWrapper>
  );
};

DisplayPdf.propTypes = {
  data: PropTypes.string,
};

DisplayPdf.defaultProps = {
  data: PropTypes.isNull,
};

export default DisplayPdf;
